// using string accessor fixes error with "Error: Cannot find symbol for node: NODE_ENV"
// eslint-disable-next-line dot-notation
export const isProduction = () => process.env['NODE_ENV'] === 'production';

export const isBrowser = () => typeof window !== 'undefined';

export const isInIframe = () => {
  if (!isBrowser()) return false;

  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export const isInPopup = () => {
  return isBrowser() && !!window.opener;
};
